import { useEffect, useState } from 'react'

interface ConfettiEffectProps {
  trigger: boolean
  onComplete?: () => void
}

export default function ConfettiEffect({ trigger, onComplete }: ConfettiEffectProps) {
  const [confetti, setConfetti] = useState<Array<{
    id: number
    left: number
    delay: number
    duration: number
    color: string
    size: number
    isCircle: boolean
    horizontalVelocity: number
  }>>([])

  useEffect(() => {
    if (trigger) {
      // Tạo 100 mảnh confetti với màu vàng và các màu khác
      const colors = ['#DFAC2A', '#FFD700', '#FFA500', '#FF8C00', '#FF6347', '#FF1493', '#00CED1', '#32CD32', '#9370DB', '#FF69B4']
      const newConfetti = Array.from({ length: 100 }, (_, i) => {
        const size = 6 + Math.random() * 8 // Kích thước từ 6px đến 14px (lớn hơn)
        const isCircle = Math.random() > 0.4 // 60% là hình tròn, 40% là hình vuông
        const horizontalVelocity = (Math.random() - 0.5) * 80 // Vận tốc ngang ngẫu nhiên (tăng lên)
        
        return {
          id: i,
          left: Math.random() * 100, // Vị trí ngang ngẫu nhiên
          delay: Math.random() * 0.2, // Độ trễ ngẫu nhiên (giảm để nổ nhanh hơn)
          duration: 2.5 + Math.random() * 1.5, // Thời gian rơi ngẫu nhiên (2.5-4 giây)
          color: colors[Math.floor(Math.random() * colors.length)],
          size,
          isCircle,
          horizontalVelocity,
        }
      })
      
      setConfetti(newConfetti)

      // Gọi callback sau khi animation hoàn thành
      const timer = setTimeout(() => {
        setConfetti([])
        if (onComplete) {
          onComplete()
        }
      }, 4500) // Sau 4.5 giây

      return () => clearTimeout(timer)
    }
  }, [trigger, onComplete])

  if (!trigger || confetti.length === 0) return null

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {confetti.map((piece) => (
        <div
          key={piece.id}
          className={`absolute top-0 confetti-piece ${piece.isCircle ? 'rounded-full' : 'rounded-sm'}`}
          style={{
            left: `${piece.left}%`,
            width: `${piece.size}px`,
            height: `${piece.size}px`,
            backgroundColor: piece.color,
            animationDuration: `${piece.duration}s`,
            animationDelay: `${piece.delay}s`,
            animationTimingFunction: 'ease-out',
            boxShadow: `0 0 12px ${piece.color}, 0 0 6px ${piece.color}`,
            '--horizontal-velocity': `${piece.horizontalVelocity}px`,
          } as React.CSSProperties}
        />
      ))}
    </div>
  )
}

